var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBackground = function SvgIconBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_background_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_background_svg__b",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9",
    rx: 6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_background_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D7E0FF",
    d: "M15.027 16.513a5.572 5.572 0 1 0 0-11.145 5.572 5.572 0 0 0 0 11.144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M22.795 20.938c2.488 2.07.808 6.062-2.181 6.062H9.386c-2.99 0-4.67-3.992-2.181-6.062C9.437 19.082 12.117 18 15 18s5.563 1.082 7.795 2.938"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M19.9 10.94a4.872 4.872 0 1 1-9.745 0 4.872 4.872 0 0 1 9.745 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeWidth: 1.2,
    d: "M22.412 21.4c1.017.846 1.191 2.076.787 3.13-.41 1.066-1.38 1.87-2.585 1.87H9.386c-1.205 0-2.175-.804-2.584-1.87-.405-1.054-.23-2.284.787-3.13 2.137-1.778 4.685-2.8 7.411-2.8s5.274 1.022 7.412 2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "m1.096 3.09 2.143-2.008M1.096 9.116l8.571-8.034M1.096 16.145l4.372-4.097M17.167 1.082 15 3.25M1.262 23.02l6.474-6.069M24.668 1.082 21.5 4.249M26.601 20.501l2.294-2.293M23 10.044l5.902-5.902M22.5 17.573l6.394-6.394"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    x: 0.5,
    y: 0.5,
    stroke: "#CCC",
    rx: 5.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_background_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgIconBackground;